<svg class="icon" [attr.width]="width" [attr.height]="height">
  <use [attr.href]="'#icon-' + name"></use>
</svg>
